<template>
  <div class="app-template-center">
    <div class="title">
      模板中心
      <div class="tip">
        <el-input
          v-model="searchText"
          size="small"
          placeholder="应用名称"
          clearable
          prefix-icon="el-icon-search"
        ></el-input>
      </div>
      <span class="icon-close pointer" @click="goBack" style="margin-left: 20px;">
        <svg-icon icon-class="close"></svg-icon>
      </span>
    </div>
    <div class="body">
      <div class="left" v-if="!_.isEmpty(menuList)">
        <ul class="menu-list" ref="menuList">
          <li
            v-for="(menu, index) in menuList"
            :key="index"
            class="menu-item"
            :class="{ active: currentIndex === index }"
            @click="selectMenu(index)"
          >
            <span style="flex: 1; font-size: 14px;">{{ menu.label }}</span>
            <span style="color: #C0C4CC; font-size: 14px;">{{ menu.count }}</span>
          </li>
        </ul>
      </div>
      <div v-else class="filter-empty">
        <svg-icon icon-class="no-template"></svg-icon>
        <div class="no-available">
          暂无模板
        </div>
      </div>
      <div
        class="main"
        ref="main"
        v-ps
        @scroll="onScrollThrottle"
        v-show="templates && templates.length > 0"
      >
        <div class="template-list">
          <div class="group" ref="group" v-for="group in templates" :key="group.groupName">
            <div style="font-size: 18px">
              {{ group.groupName }}
              <span v-if="group.groupName === '企业模板'" class="setting" @click="goSetting()">
                <svg-icon icon-class="common_setting"></svg-icon>
                <span style="margin-left: 6px; margin-right: 24px;">模板管理</span>
              </span>
            </div>
            <div style="display: flex; flex-wrap: wrap">
              <div
                v-for="template in group.groupTemplates"
                :key="template.id"
                class="template-item"
                @click="goDetail(template.id)"
              >
                <div
                  class="image"
                  :style="{
                    'background-image': `url(${
                      _.get(template, 'templateInfo.cover')
                        ? _.get(template, 'templateInfo.cover')
                        : defaultCover
                    })`
                  }"
                >
                  <div style="position: relative; padding: 14px 20px;">
                    <span v-if="group.groupName === '互联模板'" class="company-name">
                      {{ template.companyName }} 发布
                    </span>
                  </div>
                </div>
                <div class="info">
                  <div class="template-name" v-tip>{{ template.name }}</div>
                  <div class="template-desc" v-tip v-show="template.desc">{{ template.desc }}</div>
                  <div class="template-operation">
                    <base-button @click.native.stop="goPreview(template.id)" style="flex: 1">
                      预览
                    </base-button>
                    <base-button
                      v-if="template.templateInfo.onlyOne && template.existingAppId"
                      type="primary"
                      style="flex: 1;"
                      @click.native.stop="open(template.existingAppId)"
                    >
                      打开
                    </base-button>
                    <base-button
                      v-else
                      type="primary"
                      style="flex: 1;"
                      @click.native.stop="install(template.id)"
                    >
                      安装
                    </base-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getAllAppTemplates } from "@/api/user"
import BaseButton from "@/components/UIComponents/Button"
import { installAppTemplate } from "@/api/userCenter/app"
import { loadingService } from "@/utils/ui"
import templateMode from "@/mixins/templateMode"
import store from "@/store"
import { allTemplateTypes } from "@/views/Company/Manage/App/static"

export default {
  name: "appTemplateCenter",
  components: { BaseButton },
  mixins: store.getters.userInfo.userId ? [] : [templateMode],
  computed: {
    menuList() {
      return this.templates.map(menu => ({
        label: menu.groupName,
        count: menu.groupTemplates.length
      }))
    },
    templates() {
      let result = []
      let existKeys = this._.keys(this.templateList)
      this.allTemplateTypes.forEach(item => {
        if (existKeys.includes(item)) {
          result.push({
            groupName: item,
            groupTemplates: this.templateList[item].filter(template =>
              template.name.includes(this.searchText)
            )
          })
        }
      })
      return result.filter(menu => menu.groupTemplates.length > 0)
    },
    curUser() {
      return this.$store.getters.userInfo || {}
    }
  },
  watch: {
    templates() {
      this.$nextTick(() => {
        this.clientHeights = [].concat(this.$refs.group).map(g => g.clientHeight)
      })
    }
  },
  data() {
    return {
      allTemplateTypes,
      defaultCover: require("@/assets/images/template-default.png"),
      searchText: "",
      templateList: {},
      listHeight: [],
      menuScroll: {},
      templateScroll: {},
      currentIndex: 0,
      clientHeights: [],
      onScrollThrottle: null,
      from: ""
    }
  },
  created() {
    this.refresh()
    this.onScrollThrottle = this._.throttle(this.onScroll, 200)
    this.from = this.$route.query?.from
    if (this.from !== undefined) {
      localStorage.setItem("from", this.from)
    }
  },
  methods: {
    refresh() {
      getAllAppTemplates().then(templates => {
        let groupTemplateMap = this._.groupBy(templates, "templateInfo.type")
        let openTemplateList = groupTemplateMap["公开模板"]
        let openTemplateMap = this._.groupBy(openTemplateList, "templateInfo.subType")
        delete groupTemplateMap["公开模板"]
        this.templateList = Object.assign({}, groupTemplateMap, openTemplateMap)
      })
    },
    selectMenu(index) {
      this.currentIndex = index
      this.$refs.group[index].scrollIntoView()
    },
    onScroll() {
      let scrollTop = this.$refs.main.scrollTop
      let t = 0
      for (let i = 0; i < this.clientHeights.length; i++) {
        t += this.clientHeights[i]
        if (t > scrollTop) {
          this.currentIndex = i
          break
        }
      }
    },
    goSetting() {
      this.$router.push({ name: "company-app-template" })
    },
    goDetail(templateId) {
      this.$router.push({
        name: "app-template-detail",
        query: {
          id: templateId
        }
      })
    },
    goPreview(templateId) {
      this.$router.push({ name: "app-template-worksheet", params: { appId: templateId } })
    },
    goBack() {
      this.$router.push({ name: localStorage.getItem("from") })
    },
    open(appId) {
      this.$router.push({
        name: "worksheet",
        params: {
          appId: appId
        }
      })
    },
    install(templateId) {
      if (!this.curUser.companyId) {
        this.$message.error("当前尚未登录,请登录后进行此操作")
        setTimeout(() => (location.href = `/login?redirect=${this.$route.fullPath}`), 500)
        return
      }
      let loadingInstance = loadingService()
      installAppTemplate(templateId, true)
        .then(() => {
          this.$message.success("安装成功")
          this.$router.push({ name: "home" })
        })
        .finally(() => loadingInstance.close())
    }
  }
}
</script>

<style lang="scss" scoped>
.app-template-center {
  display: flex;
  flex-flow: column;
  height: 100%;
  .title {
    flex-shrink: 0;
    background: #fff;
    font-size: $font-size-title-first;
    box-shadow: 0 2px 4px 0 #d8d8d8;
    border-bottom: 1px solid #e4e4e4;
    display: flex;
    align-items: center;
    height: 52px;
    padding: 0 24px;
    box-sizing: border-box;
    .tip {
      font-size: 13px;
      margin-left: auto;
    }
  }
  .body {
    flex: 1;
    display: flex;
    overflow: hidden;
    .left {
      width: 240px;
      flex-shrink: 0;
      margin: 20px 0 20px 20px;
      .menu-list {
        border-radius: 6px;
        background: #fff;
        height: 100%;
        padding: 12px 10px;
        box-sizing: border-box;
        .menu-item {
          cursor: pointer;
          border-radius: 6px;
          padding: 8px 10px;
          display: flex;
          &.active {
            background: #1989fa;
            color: #fff;
            position: relative;
          }
        }
      }
    }
    .filter-empty {
      margin: auto;
      text-align: center;
      .svg-icon,
      i {
        font-size: 160px;
        color: #fff;
      }
      .no-available {
        color: #c0c4cc;
        font-size: 14px;
      }
    }
    .main {
      height: 100%;
      padding: 20px 20px 450px;
      box-sizing: border-box;
      width: 100%;
      .filter-empty {
        margin: 30px 10px;
        text-align: center;
        height: 100vh;
        top: 50%;
        transform: translateY(-50%);
      }
      .template-list {
        .group {
          box-sizing: border-box;
          padding-bottom: 40px;
          .setting {
            font-size: 14px;
            float: right;
            padding: 3px 0;
            cursor: pointer;
            color: #1989fa;
          }
          .template-item {
            background: #fff;
            margin: 10px 10px 0 0;
            width: 310px;
            height: 240px;
            border-radius: 6px;
            cursor: pointer;
            overflow: hidden;
            &:hover {
              .image {
                opacity: 0.64;
              }
              .info {
                top: -40px;
                .template-operation {
                  display: flex;
                }
              }
            }
            .image {
              height: 160px;
              border-radius: 6px 6px 0 0;
              background-size: cover;
              background-repeat: no-repeat;
              .template-icon {
                color: #fff;
                font-size: 90px;
              }
              .company-name {
                font-size: 14px;
                color: white;
                padding: 3px;
                border: 1px solid white;
                border-radius: 3px;
                background-color: rgba(0, 0, 0, 0.4);
              }
            }
            .info {
              height: 123px;
              padding: 14px 20px;
              box-sizing: border-box;
              position: relative;
              background: white;
              top: 0;
              transition: top 0.3s;
              .template-name {
                box-sizing: border-box;
                font-size: 16px;
                color: #606266;
                font-weight: 500;
              }
              .template-desc {
                margin-top: 8px;
                box-sizing: border-box;
                font-size: 14px;
                color: #c0c4cc;
              }
              .template-operation {
                display: none;
                margin-top: 12px;
              }
            }
          }
        }
      }
    }
  }
}
</style>
